import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IdentityService } from '../../identity.service';
import { Router } from '@angular/router';
import { UIControlService } from 'src/app/shared/uicontrol.service';

@Component({
  selector: 'app-email-login',
  templateUrl: './email-login.component.html',
  styleUrls: ['./email-login.component.scss']
})
export class EmailLoginComponent implements OnInit {
  constructor(
    public identityService: IdentityService,
    private formBuilder: FormBuilder,
    private router: Router,
    private ui: UIControlService
  ) {}

  public form: FormGroup;
  public loading = false;

  public ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  public async login() {
    this.loading = true;
    this.identityService
      .signInWithEmailAndPassword(
        this.form.value.email.toString().trim(),
        this.form.value.password
      )
      .then(result => {
        this.loading = false;
        if (result.user != null) {
          this.identityService.handleAuthenticationReroute();
        }
      })
      .catch(error => {
        this.loading = false;
        this.form.patchValue({ password: '' });
        this.ui.notifyFailure('Incorrect login details, please try again.');
      });
  }
}
